import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const Integration = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
      <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
      <meta name="format-detection" content="telephone=no" />
      <title>Top Salesforce Integration Consultant</title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <meta
        name="description"
        content="Codezix is a top Salesforce integration consultant helping businesses connect Salesforce with ERPs, CRMs, marketing tools, payment gateways, and third-party apps for a unified, automated tech ecosystem."
      />
      <meta
        name="keywords"
        content="Salesforce integration, Salesforce integration consultant, Salesforce API integration, Salesforce ERP integration, Salesforce third-party integration, Salesforce middleware, Salesforce data integration services"
      />

      {/* BreadcrumbList (Sydney page) */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://codezix.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Salesforce Integration",
      "item": "https://www.codezix.com/salesforce/integration"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "Salesforce Development Company in Sydney",
      "item": "https://www.codezix.com/salesforce/development-company-in-sydney"
    }
  ]
}
        `}
      </script>

      {/* Organization */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://codezix.com/#organization",
  "name": "Codezix",
  "legalName": "Codezix Solutions",
  "url": "https://codezix.com/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://codezix.com/assets/images/logo.webp",
    "width": 250,
    "height": 80
  },
  "image": "https://codezix.com/assets/images/logo.webp",
  "description": "Codezix is a global Salesforce consulting and cloud solution provider helping enterprises scale with robust CRM, integration, and cloud strategies.",
  "email": "info@codezix.com",
  "telephone": "+1-917-730-7436",
  "sameAs": [
    "https://www.linkedin.com/company/codezix",
    "https://www.facebook.com/codezix",
    "https://twitter.com/codezix"
  ]
}
        `}
      </script>

      {/* WebSite */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://codezix.com/#website",
  "url": "https://codezix.com/",
  "name": "Codezix",
  "publisher": {
    "@id": "https://codezix.com/#organization"
  }
}
        `}
      </script>

      {/* WebPage (Sydney development page) */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://www.codezix.com/salesforce/development-company-in-sydney#webpage",
  "url": "https://www.codezix.com/salesforce/development-company-in-sydney",
  "name": "Salesforce Development Company in Sydney",
  "inLanguage": "en-US",
  "description": "Custom Salesforce development, integrations, automation and CRM optimization services provided by Codezix for businesses in Sydney, Australia.",
  "isPartOf": {
    "@id": "https://codezix.com/#website"
  }
}
        `}
      </script>

      {/* Service — Sydney Development Page (separate) */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/development-company-in-sydney#service",
  "url": "https://www.codezix.com/salesforce/development-company-in-sydney",
  "serviceType": "Salesforce Development Services",
  "name": "Salesforce Development Company in Sydney",
  "description": "Custom Salesforce development, integrations, automation and CRM optimization services provided by Codezix for businesses in Sydney, Australia.",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization"
  },
  "areaServed": {
    "@type": "City",
    "name": "Sydney"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Salesforce Development Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Apex & Lightning Web Component Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Salesforce API Integration & Middleware"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Custom Salesforce Applications & Automation"
        }
      }
    ]
  }
}
        `}
      </script>

      {/* Service — Integration (original integration service block) */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/integration#service",
  "url": "https://www.codezix.com/salesforce/integration",
  "serviceType": "Salesforce Integration Services",
  "name": "Top Salesforce Integration Consultant",
  "description": "End-to-end Salesforce integration services by Codezix, connecting Salesforce with ERP, marketing automation, payment gateways, custom apps, and third-party platforms using APIs and middleware.",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization"
  },
  "areaServed": {
    "@type": "City",
    "name": "Global"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Salesforce Integration Offerings",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Third-Party App & SaaS Integration"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "ERP, Accounting & Billing Integration"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Custom API & Middleware Development"
        }
      }
    ]
  }
}
        `}
      </script>

      {/* ContactPoint */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "ContactPoint",
  "contactType": "customer support",
  "telephone": "+1-917-730-7436",
  "email": "info@codezix.com",
  "areaServed": ["US","UK","AE","DE","KW","AU"],
  "availableLanguage": ["English"]
}
        `}
      </script>
    </Helmet>



            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Integration Services</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/integration.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">

                        <div className="salesforce-service">
                            <p className="prose-lg wow fadeUp">
                                Salesforce integration services are designed to ensure seamless connectivity between
                                {" "} <a
                                        href="https://www.codezix.com/salesforce/development-company-in-sydney"
                                        className="text-blue-600 underline"
                                        target="_blank"
                                    >
                                        Salesforce solutions
                                    </a>{" "}
                                  and your other business-critical systems. Leveraging 10+ years of experience in CRM services, ScienceSoft helps companies overcome integration challenges of any complexity, delivering cost-effective and efficient Salesforce integrations.
                            </p>
                        </div>

                        <div className="selesforce-services mt-5">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce integration helps to:</h2>
                            </div>

                            <div className="row">
                                <div className="plateform">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Bridge the gap between front office teams (sales, marketing, and customer support) and back office departments (accounting, production, and logistics).</li>
                                            <li className="wow fadeUp prose-lg mt-3">Automate business processes from start to finish.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Provide sales reps with easy access to the functionality they need through the Salesforce interface.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Improve user experience with single sign-on across all tools.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Gain a comprehensive 360-degree view of the customer.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Ensure a consistent and seamless customer experience.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contact-shadow mt-5">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Get Your Salesforce Running</h3>
                                        <p className="prose-lg wow fadeUp">If you're looking to enhance your sales, service, or marketing efforts, Salesforce implementation is the perfect solution. Our team will deliver a reliable Salesforce solution that is fully aligned with your business needs.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button> Turn to our experts </button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="selesforce-services top">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Integration Consulting</h2>
                                <p className="wow fadeUp prose-lg text-left">Since out-of-the-box integration software often doesn’t meet the unique needs of a company, enterprises turn to experts who can provide tailored solutions. Our Salesforce integration consultants offer guidance on the best integration strategy and support projects of any complexity, helping to address challenges such as:</p>
                            </div>

                            <div className="row">
                                <div className="plateform">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg mt-3">Integration with multiple systems from different vendors.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Connecting cloud-based Salesforce to on-premises systems.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Integrating complex custom solutions.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Unifying multiple CRM solutions across regional branches.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Handling complex integration scenarios requiring flexible and scalable solutions.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Ensuring full visibility of information flows between integrated applications.</li>
                                            <li className="wow fadeUp prose-lg mt-3">Enabling real-time data synchronization.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="selesforce-services top">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Integration Options </h2>
                                <p className="wow fadeUp prose-lg text-left">At Codezix, we believe that all systems should work together seamlessly, just like the fingers on a hand. This means ensuring smooth data flow between departments, providing single access for users, and automating data synchronization.</p>
                            </div>
                            <div class="pimcore_area_technologies pimcore_area_content mt-5">
                                <div className="t-wrapper editable-wrapper">
                                    <div className="t-content">
                                        <div className="t-items-wrapper lazy entered loaded bg_lng">
                                            <div className="t-items-container">
                                                <div className="pimcore_area_technologies pimcore_area_content">
                                                    <div className="t-items mt-4">
                                                        <div className="t-item">
                                                            <div className="t-item-groups">
                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">ERP integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/oracle.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/netsuite.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/sap.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/ms-dynamics-365.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/infor.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/acumatica.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">Accounting integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/zoho.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/quick-books.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/erp/xero.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>

                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="t-items mt-4">
                                                        <div className="t-item">
                                                            <div className="t-item-groups">
                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">Marketing automation integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/marketing/market-1.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/marketing/market-2.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/marketing/market-3.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/marketing/market-4.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/marketing/market-5.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">Social Media integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/marketing/market-7.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/marketing/market-6.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>

                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/marketing/market-8.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="t-items mt-4">
                                                        <div className="t-item">
                                                            <div className="t-item-groups">
                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">CTI integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/cti/cti-1.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/cti/cti-2.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/cti/cti-3.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">Ecommerce integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/cti/cti-4.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/cti/cti-5.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/cti/cti-6.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/cti/cti-7.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="t-items mt-4">
                                                        <div className="t-item">
                                                            <div className="t-item-groups">
                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">Collaboration system integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/collaboration/col-1.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/collaboration/col-2.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/collaboration/col-3.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/collaboration/col-4.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/collaboration/col-5.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">Planner & email integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/collaboration/col-6.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/collaboration/col-7.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>

                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/collaboration/col-8.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="t-items mt-4">
                                                        <div className="t-item">
                                                            <div className="t-item-groups">
                                                                <div className="t-item-group">
                                                                    <p className="t-item-title">ITSM integration</p>
                                                                    <div className="t-item-group-technologies">
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/itsm/itsm-1.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>

                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="CSS"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/itsm/itsm-2.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="CSS"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="JavaScript"

                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/itsm/itsm-3.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="JavaScript"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="t-item-group-technology">
                                                                            <Link
                                                                                to='/integration#'
                                                                                target="_self"
                                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                                aria-label="HTML"
                                                                            >
                                                                                <img
                                                                                    src={require('../../assets/images/salesforce-technology/itsm/itsm-4.webp')}
                                                                                    width="152"
                                                                                    height="145"
                                                                                    alt="HTML"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="t-items-shadow active"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="why-winklix top">
                            <div className='explore-heading text-left'>
                                <h2>Why Choose Codezix</h2>
                            </div>
                            <div className="why-listing mt-4">
                                <ul>
                                    <li className="wow fadeUp prose-lg">Codezix is proud to be recognized as a 3-Year Champion in The Americas’ Fastest-Growing Companies Rating by the Financial Times.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in IT business.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in CRM services.</li>
                                    <li className="wow fadeUp prose-lg">200+ professionals on board.</li>
                                    <li className="wow fadeUp prose-lg">Expertise across industries such as manufacturing, retail, professional services, healthcare, banking, telecommunications, and more.</li>
                                </ul>
                            </div>

                            <div className='client-section'>
                                <div className='row top'>
                                    <Swiper
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 2,
                                                spaceBetween: 10,
                                            },
                                            640: {
                                                slidesPerView: 3,
                                                spaceBetween: 10,
                                            },
                                            768: {
                                                slidesPerView: 4,
                                                spaceBetween: 30,
                                            },
                                            1024: {
                                                slidesPerView: 5,
                                                spaceBetween: 30,
                                            },
                                        }}
                                        autoplay={{
                                            delay: 2500,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[Pagination, Autoplay]}
                                        className="testimonialSwiper-client"
                                    >
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-5.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-1.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-4.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-services mt-5">
                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Other Integration Projects We Handle</h2>
                                    <p className="wow fadeUp prose-lg text-left">Though Salesforce is a powerful platform for sales and marketing automation, some companies need to extend its capabilities. In this regard, the Codezix team can deliver Salesforce integration to:</p>
                                </div>

                                <div className="why-listing mt-4">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"> Project management software (Basecamp, Wrike)</li>
                                        <li className="wow fadeUp prose-lg"> Customer service software (Zendesk, ManageEngine)</li>
                                        <li className="wow fadeUp prose-lg"> Survey software (SurveyMonkey, Qualtrics)</li>
                                        <li className="wow fadeUp prose-lg"> Team collaboration tools (Smartsheet, SharePoint)</li>
                                        <li className="wow fadeUp prose-lg"> Customer engagement apps and live chat tools</li>
                                    </ul>
                                </div>
                                <p className="wow fadeUp prose-lg">Codezix can also assist with Salesforce integration with other CRM software and databases. For more details, don't hesitate to contact us.</p>
                            </div>

                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Technical Approaches to Salesforce Integration</h2>
                                </div>

                                <div className="why-listing mt-4">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"><strong>Direct integration solution.</strong> This involves either a direct API or database integration between Salesforce and another system. While it may be limited in flexibility and integration points, it effectively meets the need for mutual data exchange between the two systems.</li>
                                        <li className="wow fadeUp prose-lg"><strong>Solution based on integration server.</strong> A more flexible solution that minimizes the impact of system updates on the integration, reduces the need for IT resources, and offers greater control over data flows. This category includes solutions hosted both in the cloud and on-premises, as well as those utilizing hub-and-spoke or enterprise service bus (ESB) models. Integration-server-based solutions are ideal for both small-scale integration projects and large enterprises with multiple systems that need to exchange significant amounts of data.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="salesforce-product top">
                                <div className='explore-heading text-left'>
                                    <h2>What You Get with Our Integration Services</h2>
                                    <div className="row">
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">In-depth analysis of business requirements and software.</li>
                                                <li className="wow fadeUp prose-lg">Design of an integration roadmap.</li>
                                                <li className="wow fadeUp prose-lg">Development and implementation of integration solutions.</li>
                                                <li className="wow fadeUp prose-lg">Quality assurance for integration processes.</li>
                                                <li className="wow fadeUp prose-lg">Ongoing post-delivery support and maintenance.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-shadow top_padding">
                                <div className="row mb-4">
                                    <div className="valuation-box">
                                        <div className="col-md-9">
                                            <h3>Seamlessly Connect Salesforce to Your Application with Expert Solutions</h3>
                                            <p className="prose-lg wow fadeUp">Share your integration challenge with our consultants, and we'll guide you to a top-tier solution.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="button_exp mt-5">
                                                <Link to="/contact"><button>Contact us</button> </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Integration;